

import ExpireDate from '../storage/expireDate'
import Token from '../storage/token'
import User from '../storage/user'
import store  from '@/store'

export const isActiveToken = () => {
  const token = Token.get() !== null ? Token.get() : null
  const expireDate = ExpireDate.get() !== null ? ExpireDate.get() : null

  if (token && expireDate) {
    if (expireDate > new Date()) {
      return true
    }
    return false
  }
  return false

}

export const getUserRole = () => {
  if (store.getters.user) {
    return store.getters.user.role
  }
  return null
  
}

export const logoutUser = () => {
  Token.remove()
  User.remove()
  ExpireDate.remove()
  store.commit('SET_USER', null)
  
  
}